"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var node_point_1 = __importDefault(require("sigma/rendering/webgl/programs/node.point"));
var utils_1 = require("sigma/utils");
var VERTEX_SHADER_SOURCE = /*glsl*/ "\nattribute vec2 a_position;\nattribute float a_size;\nattribute vec4 a_color;\nattribute vec4 a_borderColor;\nattribute float a_borderRatio;\n\nuniform float u_sizeRatio;\nuniform float u_pixelRatio;\nuniform mat3 u_matrix;\n\nvarying vec4 v_color;\nvarying vec4 v_borderColor;\nvarying float v_border;\nvarying float v_borderRatio;\n\nconst float bias = 255.0 / 254.0;\n\nvoid main() {\n  gl_Position = vec4(\n    (u_matrix * vec3(a_position, 1)).xy,\n    0,\n    1\n  );\n\n  // Multiply the point size twice:\n  //  - x SCALING_RATIO to correct the canvas scaling\n  //  - x 2 to correct the formulae\n  gl_PointSize = a_size / u_sizeRatio * u_pixelRatio * 2.0;\n\n  v_border = (0.5 / a_size) * u_sizeRatio;\n\n  // Extract the color:\n  v_color = a_color;\n  v_color.a *= bias;\n\n  v_borderColor = a_borderColor;\n  v_borderColor.a *= bias;\n\n  v_borderRatio = 0.5 - a_borderRatio / 2.0;\n}\n";
var FRAGMENT_SHADER_SOURCE = /*glsl*/ "\nprecision mediump float;\n\nvarying vec4 v_color;\nvarying vec4 v_borderColor;\nvarying float v_border;\nvarying float v_borderRatio;\n\nconst float radius = 0.5;\nconst vec4 transparent = vec4(0.0, 0.0, 0.0, 0.0);\n\nvoid main(void) {\n  float distToCenter = length(gl_PointCoord - vec2(0.5, 0.5));\n\n  if (distToCenter < v_borderRatio - v_border)\n    gl_FragColor = v_color;\n  else if (distToCenter < v_borderRatio)\n    gl_FragColor = mix(v_borderColor, v_color, (v_borderRatio - distToCenter) / v_border);\n  else if (distToCenter < radius - v_border)\n    gl_FragColor = v_borderColor;\n  else if (distToCenter < radius)\n    gl_FragColor = mix(transparent, v_borderColor, (radius - distToCenter) / v_border);\n  else\n    gl_FragColor = transparent;\n}\n";
var FLOAT = WebGLRenderingContext.FLOAT, UNSIGNED_BYTE = WebGLRenderingContext.UNSIGNED_BYTE;
var DEFAULT_NODE_BORDER_COLOR = "#7a7a7a";
var DEFAULT_NODE_BORDER_RATIO = 0.1;
var NodePointWithBorderProgram = /** @class */ (function (_super) {
    __extends(NodePointWithBorderProgram, _super);
    function NodePointWithBorderProgram() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodePointWithBorderProgram.prototype.getDefinition = function () {
        return __assign(__assign({}, _super.prototype.getDefinition.call(this)), { ARRAY_ITEMS_PER_VERTEX: 6, VERTEX_SHADER_SOURCE: VERTEX_SHADER_SOURCE, FRAGMENT_SHADER_SOURCE: FRAGMENT_SHADER_SOURCE, ATTRIBUTES: [
                { name: "a_position", size: 2, type: FLOAT },
                { name: "a_size", size: 1, type: FLOAT },
                { name: "a_color", size: 4, type: UNSIGNED_BYTE, normalized: true },
                { name: "a_borderColor", size: 4, type: UNSIGNED_BYTE, normalized: true },
                { name: "a_borderRatio", size: 1, type: FLOAT },
            ] });
    };
    NodePointWithBorderProgram.prototype.processVisibleItem = function (i, data) {
        var array = this.array;
        var borderRatio = typeof data.borderRatio !== "number" ? DEFAULT_NODE_BORDER_RATIO : data.borderRatio;
        // borderSize takes precedence
        if (typeof data.borderSize === "number") {
            borderRatio = data.borderSize / data.size;
        }
        array[i++] = data.x;
        array[i++] = data.y;
        array[i++] = data.size;
        array[i++] = (0, utils_1.floatColor)(data.color);
        array[i++] = (0, utils_1.floatColor)(data.borderColor || DEFAULT_NODE_BORDER_COLOR);
        array[i] = borderRatio;
    };
    return NodePointWithBorderProgram;
}(node_point_1["default"]));
exports["default"] = NodePointWithBorderProgram;
